import React, { useState } from 'react';
import { useChangePassword } from './auth.hooks';
import { useDispatch } from 'react-redux';
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import { showAlert } from '../../store/slices/alertSlice';
import { constants } from '../../constants';
export default function ChangePasswordPage() {
  const dispatch = useDispatch();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});

  const { mutate, isPending } = useChangePassword();
  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};

    if (!currentPassword.trim()) {
      errors.current_password = ['Current password is required.'];
    }

    if (!newPassword.trim()) {
      errors.new_password = ['New password is required.'];
    } else if (newPassword.length < 8) {
      errors.new_password = ['New password must be at least 8 characters.'];
    }

    if (!confirmPassword.trim()) {
      errors.new_password_confirmation = ['Please confirm the new password.'];
    } else if (newPassword !== confirmPassword) {
     errors.new_password_confirmation = ['Passwords do not match.'];
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setFieldErrors({});

    mutate(
      {
      current_password: currentPassword,
      new_password: newPassword,
      new_password_confirmation: confirmPassword,
      },
      {
        onError: (error) => {
          if (error?.response?.status === 422) {
            setFieldErrors(error.response?.data?.errors || {});
          } else {
            dispatch(showAlert({
                severity: constants.ERROR,
              title: 'Password Updation failed: ' + (error.message || 'Unknown error'),
            }));
          } 
        },
        onSuccess: () => {
          dispatch(
            showAlert({
              severity: constants.SUCCESS,
              title: 'Password changed successfully',
            })
          );
          setCurrentPassword('');
          setNewPassword('');
          setConfirmPassword('');
        },
      }
    );
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ mt: 8, p: 4 }}>
        <Typography variant="h6" gutterBottom>
          Change Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Current Password"
            type="password"
            fullWidth
            margin="normal"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            error={!!fieldErrors.current_password}
            helperText={fieldErrors.current_password?.[0]}
            required
          />
          <TextField
            label="New Password"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            error={!!fieldErrors.new_password}
            helperText={fieldErrors.new_password?.[0]}
            required
          />
          <TextField
            label="Confirm New Password"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!fieldErrors.new_password_confirmation}
            helperText={fieldErrors.new_password_confirmation?.[0]}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            disabled={isPending}
          >
            {isPending ? <CircularProgress size={24} /> : 'Change Password'}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
